/** Hayriya modalida tanlov uchun summa (so'm) */
export const PRESET_AMOUNTS = [10_000, 50_000, 100_000, 500_000, 1_000_000] as const;

export const MIN_DONATE_AMOUNT = 1_000;
